import Vue from 'vue';
import Toast from '@/plugins/alerts';

const toastMessage = {
  errorLoading(message = 'Erro ao carregar dados') {
    Toast.fire({
      icon: 'error',
      title: message,
    });
  },
  successSave(message = 'Dados salvos com sucesso') {
    Toast.fire({
      icon: 'success',
      title: message,
    });
  },
  errorSave(message = 'Erro ao salvar dados') {
    Toast.fire({
      icon: 'error',
      title: message,
    });
  },
  successDestroy(message = 'Item excluído com sucesso') {
    Toast.fire({
      icon: 'success',
      title: message,
    });
  },
  errorDestroy(message = 'Erro ao excluído item') {
    Toast.fire({
      icon: 'error',
      title: message,
    });
  },
  successUpdate(message = 'Item editado com com sucesso') {
    Toast.fire({
      icon: 'success',
      title: message,
    });
  },
  notPermission(message = 'Sem permissão para esse recurso') {
    Toast.fire({
      icon: 'error',
      title: message,
    });
  },
  errorAuth(message = 'Erro ao autenticar o usuário') {
    Toast.fire({
      icon: 'error',
      title: message,
    });
  },
  errorValidation(message = 'Revise os dados informados') {
    Toast.fire({
      icon: 'error',
      title: message,
    });
  },
};

export const toastResponseError = ({ response }) => {
  const { status } = response;
  switch (status) {
    case 401:
      toastMessage.errorAuth();
      break;
    case 403:
      toastMessage.notPermission();
      break;
    case 422:
      toastMessage.errorValidation();
      break;
    default:
      toastMessage.errorLoading();
      break;
  }
};

export const confirmDestroyAlert = (name) => Vue.swal({
  title: 'Excluir',
  icon: 'question',
  html: `Deseja realmente excluir <b><em>${name}</em></b>?`,
  showCancelButton: true,
  confirmButtonText: 'Sim',
  cancelButtonText: 'Não',
  confirmButtonColor: '#48BB78',
  cancelButtonColor: '#F56565',
});

export const confirmDestroyAlertMessage = (title, message) => Vue.swal({
  title,
  icon: 'question',
  text: message,
  showCancelButton: true,
  confirmButtonText: 'Sim',
  cancelButtonText: 'Não',
  confirmButtonColor: '#48BB78',
  cancelButtonColor: '#F56565',
});

export const confirmDetachAlert = (name) => Vue.swal({
  title: 'Desvincular',
  icon: 'question',
  html: `Deseja realmente desvincular <b><em>${name}</em></b>?`,
  showCancelButton: true,
  confirmButtonText: 'Sim',
  cancelButtonText: 'Não',
  confirmButtonColor: '#48BB78',
  cancelButtonColor: '#F56565',
});

export default toastMessage;
